import * as React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import { attachAutocomplete, buildAddressAutofillValues, isPlacesUsable, } from './google_places';
import { dynamicFieldSx } from './dynamic_form_styles';
var DEFAULT_ADDRESS_MAX_LENGTH = 100;
var ATTACH_DELAY_MS = 100;
var AddressAutoCompleteField = function (_a) {
    var _b, _c;
    var field = _a.field, value = _a.value, error = _a.error, isDisabled = _a.isDisabled, label = _a.label, adornments = _a.adornments, onChange = _a.onChange, onBlur = _a.onBlur, onAutofill = _a.onAutofill;
    var inputRef = React.useRef(null);
    var fieldName = field.name, addressAutofill = field.addressAutofill;
    var handlePlaceRef = React.useRef();
    handlePlaceRef.current = function (place) {
        var _a, _b;
        var values = buildAddressAutofillValues(place, addressAutofill !== null && addressAutofill !== void 0 ? addressAutofill : {});
        if (!values) {
            return;
        }
        values[fieldName] = values[fieldName] || String((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '');
        if (onAutofill) {
            onAutofill(values);
        }
        else {
            onChange(fieldName, values[fieldName]);
        }
    };
    React.useEffect(function () {
        var isCancelled = false;
        var detach = null;
        var attachTimer = setTimeout(function () {
            isPlacesUsable().then(function (isUsable) {
                if (isCancelled || !isUsable || !inputRef.current) {
                    return;
                }
                detach = attachAutocomplete(inputRef.current, function (place) { var _a; return (_a = handlePlaceRef.current) === null || _a === void 0 ? void 0 : _a.call(handlePlaceRef, place); });
            });
        }, ATTACH_DELAY_MS);
        return function () {
            isCancelled = true;
            clearTimeout(attachTimer);
            detach === null || detach === void 0 ? void 0 : detach();
        };
    }, [fieldName]);
    return (React.createElement(MuiTextField, { fullWidth: true, size: "small", inputRef: inputRef, id: fieldName, name: fieldName, label: label, placeholder: (_b = field.placeholder) !== null && _b !== void 0 ? _b : field.label, value: value !== null && value !== void 0 ? value : '', onChange: function (event) { return onChange(fieldName, event.target.value); }, onBlur: function () { return onBlur(fieldName); }, disabled: isDisabled, error: Boolean(error), helperText: error, inputProps: {
            maxLength: (_c = field.maxLength) !== null && _c !== void 0 ? _c : DEFAULT_ADDRESS_MAX_LENGTH,
            autoComplete: 'off',
        }, InputProps: adornments, sx: dynamicFieldSx }));
};
export default React.memo(AddressAutoCompleteField);
